<app-offline-banner
  [isOffline]="layoutService.isOffline()"
  [pendingCount]="layoutService.pendingSync()"
  [syncing]="layoutService.isSyncing()"
  (syncRequested)="onSyncRequested()" />

@if (layoutService.isLoading()) {
  <div class="fixed top-0 left-0 right-0 z-50 h-1 overflow-hidden">
    <div class="h-full w-full animate-pulse"></div>
  </div>
}

<div class="h-full overflow-hidden">
  <ng-content />
</div>
